// extracted by mini-css-extract-plugin
export default {"list":"ListWithDot_list__Boobm","listItem":"ListWithDot_listItem__ECh8M","markedList":"ListWithDot_markedList__eezCd","itemText":"ListWithDot_itemText__y7vlk"};